module.exports = __webpack_public_path__ + "img/registered-users.6a35bba4.svg";